import { axiosInstance } from "../Middleware";
import { ChangeStatusValidationReponse } from "./type";

export class ValidationReponseApi {
    public static async updateValidationReponse(data: ChangeStatusValidationReponse) {
        const response = await axiosInstance.put("/personnel/personnel/validationsreponses/changeStatus", data)
        return response
    }
}
